const login_es = require('./login.json')
export default login_es